import Vue from 'vue';
import Vuex, { Module } from 'vuex';
import axios from 'axios';

import { endpoints } from '@/endpoints/endpoints';
import { handleError } from '@/utils/helperFunctions';

// import { } from '@/definitions/definitions';

Vue.use(Vuex);

export const watchlist: Module<any, any> = {
  state: {
    watchlist: null,
    open: false,
    fetching: false,
    activeWatchlistItem: null,
    editWatchlist: null,
  },
  mutations: {
    toggleWatchlist(state: any, data: boolean) {
      state.open = data;
    },
    setWatchlist(state: any, data: any) {
      state.watchlist = data;
    },
    setFetching(state: any, data: boolean) {
      state.fetching = data;
    },
    setActiveWatchlistItem(state: any, data: boolean) {
      state.activeWatchlistItem = data;
    },
    setEditWatchlist(state: any, data: any) {
      state.editWatchlist = data;
    },
  },
  actions: {
    async getWatchlist(state: any, data: any) {
      this.commit('setFetching', true);
      // adds consultant ID if applicable
      const userInfoId = this.state.account.details.role.includes('consultant') ?
      ('&userinfoId=' + this.state.account.details.userId) : '';
      const res = await axios
        .get(
          endpoints.getWatchlist +
            '?whiteLabelId=' +
            parseInt(this.state.account.details.whiteLabelId, 10) +
            '&bostonId=' +
            this.state.account.details.bostonId,
          {
            headers: {
              Authorization: 'bearer ' + this.state.account.token,
            },
          },
        )
        .then((response) => {
          if (response.data.Data.WatchlistFundsInfos) {
            this.commit('setWatchlist', response.data.Data.WatchlistFundsInfos);
            this.commit('setFetching', false);
          } else {
            this.commit('setCart', []);
            this.commit('setFetching', false);
          }
          return response.data;
        })
        .catch((err) => {
          const msg = handleError(err, 'Sorry! looks like something went wrong while loading your watchlist');
          this.dispatch('addError', msg);
          this.commit('setWatchlist', []);
        });
    },
    async addToWatchlist(state: any, data: any) {
      this.commit('setFetching', true);
      const reqBody: any = {
        BostonId: this.state.account.details.bostonId,
        FundId: data.FundId,
        NAV: data.LatestNav ?? data.NAV,
      };
      if (this.state.account.details.role.includes('consultant')) {
        reqBody.RoleInfoId = this.state.account.details.userId;
      }
      const res = await axios
        .post(
          endpoints.addWatchlist,
          reqBody,
          {
            headers: {
              Authorization: 'bearer ' + this.state.account.token,
            },
          },
        )
        .then((response) => {
          this.commit('updateSnackbarMessage', 'Added ' + data.FundName + ' to Watchlist');
          this.dispatch('getWatchlist');
          this.commit('setFetching', false);
          return response.data;
        })
        .catch((err) => {
          const msg = handleError(err, 'Sorry! looks like something went wrong while trying to add to your watchlist');
          this.dispatch('addError', msg);
          this.commit('setFetching', false);
          return err;
        });
    },
    async addClientWatchlist(state: any, data: any) {
      this.commit('setFetching', true);
      const res = await axios
        .post(
          endpoints.addClientWatchlist,
          data,
          {
            headers: {
              Authorization: 'bearer ' + this.state.account.token,
            },
          },
        )
        .then((response) => {
          this.commit('setFetching', false);
          this.commit('updateSnackbarMessage', response.data.Data );
          return response.data;
        })
        .catch((err) => {
          const msg = handleError(err, 'Sorry! looks like something went wrong while trying to add to your client\s watchlist');
          this.dispatch('addError', msg);
          this.commit('setFetching', false);
          return err;
        });
    },
    async removeFromWatchlist(state: any, data: any) {
      this.commit('setFetching', true);
      const reqBody: any = {
        ShoppingBasketId: data.ShoppingBasketId,
        BostonId: this.state.account.details.bostonId,
        FundId: data.FundId,
      };
      if (this.state.account.details.role.includes('consultant')) {
        reqBody.RoleInfoId = this.state.account.details.userId;
      }
      const res = await axios
        .post(
          endpoints.removeWatchlist,
          reqBody,
          {
            headers: {
              Authorization: 'bearer ' + this.state.account.token,
            },
          },
        )
        .then((response) => {
          this.commit('updateSnackbar', {
            message: 'Removed ' + data.FundName + ' from Watchlist',
            type: 'default',
            hasClose: false,
            hasIcon: false,
            autoClose: true,
          });
          this.dispatch('getWatchlist');
          this.commit('setFetching', false);
          return response.data;
        })
        .catch((err) => {
          const msg = handleError(err, 'Sorry! looks like something went wrong while trying to delete item from your watchlist');
          this.dispatch('addError', msg);
          this.commit('setFetching', false);
        });
    },

    async setActiveWatchlistItem(state: any, data) {
      this.commit('setActiveWatchlistItem', data);
    },

    async updateWatchlist(state, data) {
      const body = {
        ShoppingBasketId: data.ShoppingBasketId,
        BostonId: this.state.account.details.bostonId,
        GainRate: data.GainRate,
        FallRate: data.FallRate,
      };
      const res = await axios
        .post(
          endpoints.editWatchlist,
          body,
          {
            headers: {
              Authorization: 'bearer ' + this.state.account.token,
            },
          },
        )
        .then((response) => {
          this.dispatch('getWatchlist');
          this.commit('updateSnackbarMessage', 'Updated Watchlist');
          this.commit('setEditWatchlist', null);
          return response.data;
        })
        .catch((err) => {
          const msg = handleError(err, 'Sorry! looks like something went wrong while trying to update your watchlist');
          this.dispatch('addError', msg);
          return err;
        });
    },

    async toggleWatchlist(state, data) {
      this.commit('toggleWatchlist', data);
      this.commit('setEditWatchlist', false);
    },
  },
};
